<template>
    <div class="compare-similar-para-bar">
        <div class="compare-similar-para-bar__inner">
            <template v-if="showSimilarParaBar">
                <span>
                    {{ t('patent-view.compareView.totalSimilarPara', { n: curSimilarParaListLeng }) }}
                </span>
                <span class="compare-similar-para-bar__para">
                    {{ t('patent-view.compareView.similarPara') }} {{ curSimilarParaNum }}
                </span>
                <button
                    class="compare-similar-para-bar__btn th-btn th-btn-only-icon th-btn-plain"
                    :disabled="prevDisabled"
                    @click="scrollToSimilar(curSimilarParaNumSerialIdx - 1)"
                >
                    <svg width="24" height="24" class="th-btn-icon">
                        <use xlink:href="#SolidArrowUp" />
                    </svg>
                </button>
                <span class="compare-similar-para-bar__count">
                    <span>{{ curSimilarParaNumSerialIdx }}</span>
                    <span class="compare-similar-para-bar__count__all">/ {{ curSimilarParaListLeng }}</span>
                </span>
                <button
                    class="compare-similar-para-bar__btn th-btn th-btn-only-icon th-btn-plain"
                    :disabled="nextDisabled"
                    @click="scrollToSimilar(curSimilarParaNumSerialIdx + 1)"
                >
                    <svg width="24" height="24" class="th-btn-icon">
                        <use xlink:href="#SolidArrowDown" />
                    </svg>
                </button>
            </template>
            <template v-else-if="showWordingNotFoundBar">
                <span>
                    {{ t('patent-view.compareView.noFindSimilar') }}
                </span>
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from '@/composables/use-i18n';
import { useSimilarParaScroll } from '@/composables/use-similar-para-scroll';
import { useSimilarParagraph } from '@/composables/use-similar-paragraph';
import { useCompareWording } from '@/composables/use-compare-wording';
import '@patsnap-ui/icon/assets/solid/ArrowUp.svg';
import '@patsnap-ui/icon/assets/solid/ArrowDown.svg';

const { t } = useI18n();
const {
    curSimilarParaNum,
    curSimilarParaNumSerialIdx,
    curSimilarParaListLeng,

    showSimilarParaBar,

    changeSimilarParaNumSerialIdx,
    getCurScrollInfo,
} = useSimilarParaScroll();

const { scrollToSimilarPara } = useSimilarParagraph();

const { showWordingNotFoundBar } = useCompareWording();

const prevDisabled = computed(() => {
    return curSimilarParaNumSerialIdx.value <= 1;
});

const nextDisabled = computed(() => {
    return curSimilarParaNumSerialIdx.value >= curSimilarParaListLeng.value;
});

const scrollToSimilar = (index) => {
    changeSimilarParaNumSerialIdx(index);
    const params = getCurScrollInfo('right');
    scrollToSimilarPara(params);
};

</script>


<style lang="scss">
.compare-similar-para-bar {
    background-image: linear-gradient(0deg, #0a3dff, #0dacba, #18ec81);
    height: 32px;
    width: calc(100% - 48px);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1px;

    &__inner {
        height: 100%;
        width: 100%;
        border-radius: 4px;
        padding: 0px 16px 0 8px;
        line-height: 24px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__para {
        padding: 4px;
        border-radius: 4px;
        display: inline-block;
        line-height: 12px;
        font-size: 12px;
        color: #0456D1;
        margin-left: 4px;
        background: linear-gradient(180deg, rgba(24, 236, 129, 0.2) 0%, rgba(13, 172, 186, 0.2) 42.43%, rgba(10, 61, 255, 0.2) 100%),
        linear-gradient(0deg, #FFFFFF, #FFFFFF);
    }

    &__btn {
        margin: 0 8px;
        cursor: pointer;
    }

    &__count {
        margin: 0 4px;
        font-size: 12px;

        &__all {
            color: $text-hint;
        }
    }
}
</style>
